// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8b1e8e58","139":"8e82c200","161":"10e3ac15","193":"74608981","387":"689133fd","434":"01b69295","453":"e10d0558","506":"06f45f1d","574":"691fda21","602":"33a2bc0d","612":"6721fccb","997":"ff638c7d"}[chunkId] + ".chunk.js";
};